<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="plus" viewBox="0 0 160 160">
    <rect class="vertical-line" x="70" width="20" height="160"/>
    <rect class="horizontal-line" y="70" width="160" height="20"/>
  </svg>
</template>
